export default __webpack_public_path__ + "static/media/audio4.8b455eed.vtt";